<template>
  <div class="tw-my-6 tw-flex tw-justify-between">
    <cl-form-input
      id="user_uuid"
      type="hidden"
      :value="uuid"
      test-id="profile-user-uuid"
    />
    <cl-form-input
      id="user_name"
      type="hidden"
      :value="name"
      test-id="profile-user-name"
    />
    <cl-form-input
      id="user_email"
      type="hidden"
      :value="email"
      test-id="profile-user-email"
    />
    <cl-form-input
      id="user_organisation"
      type="hidden"
      :value="organisation"
      test-id="profile-user-organisation"
    />
    <div>
      <div class="tw-flex tw-items-center tw-gap-4">
        <div
          v-if="pageMeta.icon"
          :data-test-id="`page-title-solution-icon-prefix`"
          class="tw-mb-3 tw-w-9 tw-h-9 tw-p-0.5 tw-m-0 tw-border-2 tw-bg-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-place-self-center tw-border-dorian-gray-200"
        >
          <component :is="pageMeta.icon" />
        </div>
        <div class="tw-flex tw-gap-2 tw-items-center">
          <cl-heading size="h3">
            {{ pageMeta.title }}
          </cl-heading>
          <t-page-header-info
            v-if="pageMeta.info"
            :docs-link="pageMeta.info.docsLink"
            :text="pageMeta.info.text"
          />
        </div>
        <cl-pill
          class="tw-mb-3"
          v-if="pageMeta.pill"
          :variant="pageMeta.pill.variant"
        >
          <div class="tw-text-sm">
            {{ pageMeta.pill.text }}
          </div>
        </cl-pill>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import TPageHeaderInfo from "./TPageHeaderInfo.vue";
import { ProductLink, UserLink } from "./TPageHeader.types";
import { PageMeta } from "@/store/modules/pageMeta";

type Props = {
  userLinks: UserLink[];
  productLinks: ProductLink[];
  dataTestId: string;
};

defineProps<Props>();

const store = useStore();

const pageMeta = computed<PageMeta>(() => store.getters["pageMeta/pageMeta"]);
const authUser = computed(() => store.getters["authentication/authUser"]);

const name = computed(() => authUser.value?.accountname);
const organisation = computed(() => authUser.value?.organisation);
const email = computed(() => authUser.value?.email);
const uuid = computed(() => authUser.value?.uuid);
</script>
